import axios from '../../axios'

/*
 * 角色管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/system/sysRole/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/system/sysRole/delete',
        method: 'post',
        data
    })
}
// 列表页查询
export const list = (data) => {
    return axios({
        url: '/system/sysRole/list',
        method: 'post',
        data
    })
}
// 权限树和角色权限查询
export const findRolePrivileges = (params) => {
    return axios({
        url: '/system/sysRole/findRolePrivileges',
        method: 'post',
        params
    })
}
// 保存角色菜单集合
export const saveRolePrivileges = (data) => {
    return axios({
        url: '/system/sysRole/saveRolePrivileges',
        method: 'post',
        data
    })
}
// 用户选择角色
export const selectRoles = (params) => {
  return axios({
    url: '/system/sysRole/selectRoles',
    method: 'post',
    params
  })
}

// 保存角色用户集合

export const saveRoleUsers =(data) =>{
    return axios({
      url:'/sysRole/saveRoleUsers',
      method:'post',
      data
    })
}

// // 获取角色用户集合
// export const searchRoleUsers =(data) =>{
//   return axios({
//     url:'/sysRole/searchRoleUsers',
//     method:'post',
//     data
//   })
// }

// 查找部门用户集合
export const findDeptUserTree = (params) => {
  return axios({
    url: '/system/sysRole/findDeptUserTree',
    method: 'post',
    params
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/sys/role.js